<div #scrollTarget></div>
<div class="accordion-item-container">
  <div class="title-container"
    (click)="toggleEditMode(control(), index())"
    [ngClass]="{'disabled': disableEditMode()}"
    [attr.name]="'accordion-title-' + index()"
    [id]="'accordion-title-container-' + index()">
    <div class="text-container"
      [ngClass]="{'inline-header': inlineHeader()}">
      <label class="one-form-question item-title">
        {{control()?.get('title')?.value}}
      </label>
      @if (!getIsEditMode(control(), index())) {
        <div
          class="header-container">
          <ng-container *ngTemplateOutlet="header"></ng-container>
        </div>
      }

    </div>
    <a class="action-expand-menu chevron down"
      data-toggle="collapse"
      [ngClass]="{'flip-image': getIsEditMode(control(), index())}"
      [name]="'accordion-title' + index()"
      [id]="getImageId(control(), index())"
      [attr.data-target]="'#image-section-container-'+ index()">
      <svg width="24"
        height="24"
        viewBox="0 0 34 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
          clip-rule="evenodd"
          d="M32.7148 6.33697C32.7148 7.00042 32.4357 7.66117 31.8861 8.14354L18.4258 19.9521C17.4564 20.8024 15.9733 20.8024 15.0039 19.9521L1.54354 8.14354C0.507097 7.23427 0.432684 5.68844 1.3777 4.69145C2.32297 3.69421 3.92907 3.62285 4.96551 4.53188L16.7148 14.8395L28.4642 4.53188C29.5006 3.62285 31.1067 3.69421 32.052 4.69145C32.4959 5.15989 32.7148 5.74953 32.7148 6.33697Z"
          fill="#006A99" />
        </svg>
      </a>
    </div>

    @if (getIsEditMode(control(), index())) {
      <div
        class="accordion-content-wrapper">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    }
  </div>